import React from "react";
import { Row, Col, Card, Typography } from "antd";
import RenewalTrends from "../RenewalTrends";
import AwaitingDecision from "../AwaitingDecision";
import AcceptedRenewals from "../AcceptedRenewals";
import RenewalDeclineReasons from "../RenewalDeclineReasons";
import BookingCard from "../../Booking/BookingCard";
import { currencyFormat } from "../../../../../utils/media";
import { getBookingsWidgetAccess } from "../../Booking/BookingOverview/utili";
import { useGetRenewalsCard } from "../hooks/useGetRenewalsCard";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";

const { Title } = Typography;

const bookingData2 = [
  {
    key: "renewed-at-higher-rent",
    title: "Renewed at Higher Rent",
    value: "5",
    extraText: currencyFormat("345000"),
    style: {
      backgroundColor: "#ffffff",
      color: "#123A55",
      minHeight: "200px",
    },
  },
  {
    key: "avg-rent-increase",
    title: "Avg. Rent Increase / Decrease",
    value: "3",
    extraText: currencyFormat("175000"),
    style: {
      backgroundColor: "#F8F8F8",
      color: "#123A55",
      minHeight: "200px",
    },
  },
];

const RenewalOverview = React.memo((props: any) => {
  const { widgetAccess } = props;
  const filterData = useDashboardFilterContext();
  const { isLoading, renewalCardData }: any = useGetRenewalsCard(filterData);

  return (
    <>
      <Card
        style={{
          margin: "0 16px",
          border: "none",
          borderRadius: 8,
        }}
      >
        <Title level={4} style={{ marginBottom: 16 }}>
          <span style={{ fontWeight: 700, color: "#1F5782" }}>RENEWALS</span>{" "}
          <span style={{ fontWeight: 400, color: "#1F5782" }}>OVERVIEW</span>
        </Title>
        <>
          {getBookingsWidgetAccess(widgetAccess, "renewalOverview") && (
            <Row gutter={[8, 8]} justify="space-between">
              {renewalCardData?.map((item, index) => (
                <Col
                  key={item.key}
                  xs={24}
                  sm={12}
                  style={{ display: "flex" }}
                  md={index === 0 ? 6 : index === 1 ? 6 : 6}
                  lg={index === 0 ? 6 : index === 1 ? 6 : 6}
                >
                  <BookingCard isLoading={isLoading} {...item} />
                </Col>
              ))}
            </Row>
          )}
          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            {getBookingsWidgetAccess(widgetAccess, "renewalOverview") && (
              <Col xs={24} sm={12} md={5}>
                <Row gutter={[0, 16]}>
                  <Col xs={24}>
                    {bookingData2.map((item, index) => (
                      <div key={index} style={{ marginBottom: "16px" }}>
                        <BookingCard {...item} />
                      </div>
                    ))}
                  </Col>
                </Row>
              </Col>
            )}

            <Col xs={24} sm={12} md={19}>
              {getBookingsWidgetAccess(widgetAccess, "renewalTrends") && (
                <RenewalTrends />
              )}
            </Col>
          </Row>
        </>

        <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
          <Col xs={24} sm={12} md={7}>
            {getBookingsWidgetAccess(widgetAccess, "awaitingDecision") && (
              <AwaitingDecision />
            )}
          </Col>
          <Col xs={24} sm={12} md={7}>
            {getBookingsWidgetAccess(widgetAccess, "acceptedRenewals") && (
              <AcceptedRenewals />
            )}
          </Col>
          <Col xs={24} sm={12} md={10}>
            {getBookingsWidgetAccess(
              widgetAccess,
              "renewalsDeclineReasons"
            ) && <RenewalDeclineReasons />}
          </Col>
        </Row>
      </Card>
    </>
  );
});

export default RenewalOverview;
